export const firstLetterToUpperCase = (text: string): string => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const removeNonAlphanumericAtEnd = (text: string): string => {
    return text.replace(/[^a-zA-Z0-9]*$/, '');
};
